"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rendall API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RiskScoreDetailsToJSON = exports.RiskScoreDetailsFromJSONTyped = exports.RiskScoreDetailsFromJSON = exports.instanceOfRiskScoreDetails = void 0;
var RiskCount_1 = require("./RiskCount");
var RiskScore_1 = require("./RiskScore");
/**
 * Check if a given object implements the RiskScoreDetails interface.
 */
function instanceOfRiskScoreDetails(value) {
    var isInstance = true;
    isInstance = isInstance && "industry" in value;
    isInstance = isInstance && "latest" in value;
    isInstance = isInstance && "unresolvedRisks" in value;
    isInstance = isInstance && "newRisks" in value;
    isInstance = isInstance && "mitigatedRisks" in value;
    isInstance = isInstance && "acceptedRisks" in value;
    return isInstance;
}
exports.instanceOfRiskScoreDetails = instanceOfRiskScoreDetails;
function RiskScoreDetailsFromJSON(json) {
    return RiskScoreDetailsFromJSONTyped(json, false);
}
exports.RiskScoreDetailsFromJSON = RiskScoreDetailsFromJSON;
function RiskScoreDetailsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'industry': (0, RiskScore_1.RiskScoreFromJSON)(json['industry']),
        'latest': (0, RiskScore_1.RiskScoreFromJSON)(json['latest']),
        'unresolvedRisks': (0, RiskCount_1.RiskCountFromJSON)(json['unresolvedRisks']),
        'newRisks': (0, RiskCount_1.RiskCountFromJSON)(json['newRisks']),
        'mitigatedRisks': (0, RiskCount_1.RiskCountFromJSON)(json['mitigatedRisks']),
        'acceptedRisks': (0, RiskCount_1.RiskCountFromJSON)(json['acceptedRisks']),
    };
}
exports.RiskScoreDetailsFromJSONTyped = RiskScoreDetailsFromJSONTyped;
function RiskScoreDetailsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'industry': (0, RiskScore_1.RiskScoreToJSON)(value.industry),
        'latest': (0, RiskScore_1.RiskScoreToJSON)(value.latest),
        'unresolvedRisks': (0, RiskCount_1.RiskCountToJSON)(value.unresolvedRisks),
        'newRisks': (0, RiskCount_1.RiskCountToJSON)(value.newRisks),
        'mitigatedRisks': (0, RiskCount_1.RiskCountToJSON)(value.mitigatedRisks),
        'acceptedRisks': (0, RiskCount_1.RiskCountToJSON)(value.acceptedRisks),
    };
}
exports.RiskScoreDetailsToJSON = RiskScoreDetailsToJSON;
